var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { BaseInstructionComponent } from 'investor/components/investor-instructions/base';
import { InstructionsService } from 'investor/services';
import * as fromInvestor from 'investor/store/investor.store';
import { ToastrService } from 'ngx-toastr';
import { combineLatest } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DateFormatterService, LoggerService } from 'shared/services';
import { LoadingAction, StopLoadingAction } from 'shared/store';
import * as fromShared from 'shared/store/shared.store';
var StatementInstructionComponent = /** @class */ (function (_super) {
    __extends(StatementInstructionComponent, _super);
    function StatementInstructionComponent(investorStore, sharedStore, instructionService, formBuilder, dateFormatter, modalService, loggerService, toastr) {
        var _this = _super.call(this, toastr, loggerService, modalService) || this;
        _this.investorStore = investorStore;
        _this.sharedStore = sharedStore;
        _this.instructionService = instructionService;
        _this.formBuilder = formBuilder;
        _this.dateFormatter = dateFormatter;
        _this.hasHoldings = false;
        _this.modalTitle = 'Statement Request';
        return _this;
    }
    StatementInstructionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sharedStore.dispatch(new LoadingAction());
        combineLatest(this.sharedStore.select(fromShared.selectUser), this.investorStore.select(fromInvestor.selectInvestmentAccounts), this.investorStore.select(fromInvestor.selectSelectedInstructionAccount), function (user, accounts, selectedAccountNumber) {
            return { user: user, accounts: accounts, selectedAccountNumber: selectedAccountNumber };
        }).subscribe(function (_a) {
            var user = _a.user, accounts = _a.accounts, selectedAccountNumber = _a.selectedAccountNumber;
            if (!accounts) {
                return;
            }
            _this.user = user;
            _this.sharedStore.dispatch(new StopLoadingAction());
            _this.selectedAccountNumber = selectedAccountNumber;
            var selectedAccount = accounts.find(function (acct) {
                return acct.accountNumber === _this.selectedAccountNumber;
            });
            _this.hasHoldings =
                selectedAccount.accountPortfolios.filter(function (acc) { return _this.instructionService.canInstructOnAccountItem(acc); }).length > 0;
        });
        this.createForm();
    };
    StatementInstructionComponent.prototype.ngOnDestroy = function () { };
    StatementInstructionComponent.prototype.canSubmit = function () {
        return this.instructionForm.valid;
    };
    StatementInstructionComponent.prototype.submit = function () {
        var _this = this;
        if (this.canSubmit()) {
            this.sharedStore.dispatch(new LoadingAction());
            var payLoad = {
                fromDate: this.dateFormatter.forApi(this.instructionForm.value.fromDate),
                toDate: this.dateFormatter.forApi(this.instructionForm.value.toDate),
                accountNumber: this.selectedAccountNumber,
                caseTypeId: null,
                ucn: this.user.customerDetails.ucn,
            };
            this.instructionService
                .submitStatementInstruction(payLoad)
                .pipe(finalize(function () { return _this.sharedStore.dispatch(new StopLoadingAction()); }))
                .subscribe(function (result) { return _this.handleResponse(result, _this.modalTitle); }, function () { return _this.handleSubmitError(_this.modalTitle); });
        }
        else {
            this.markAsTouched(this.instructionForm);
        }
    };
    StatementInstructionComponent.prototype.cancel = function () {
        this.instructionForm.reset();
    };
    StatementInstructionComponent.prototype.createForm = function () {
        this.instructionForm = this.formBuilder.group({
            fromDate: ['', Validators.required],
            toDate: ['', Validators.required],
        });
    };
    return StatementInstructionComponent;
}(BaseInstructionComponent));
export { StatementInstructionComponent };
